const config = {
  // TEMPORARY: api.heroshhi.com not resolving reliably (NXDOMAIN) as of 07 Sep.
  // Using Railway's own domain until DNS is confirmed stable.
  // Restore to: 'https://api.heroshhi.com'
  API_URL: 'https://whatsapp-manager-backend-production-818c.up.railway.app'
};

export default config;
